module.exports = __webpack_public_path__ + "static/media/elva@3x.cae76d84.png";